import { useState } from 'react';
import { Box, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import CustomModal from 'src/components/modal/customModal';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import LoadingButton from '@mui/lab/LoadingButton';
import { styled, useTheme } from '@mui/material/styles';
import { allowedCountries, ROUTE, PLAN_TYPE, WA_TEMPLATE_TYPE } from 'src/lib/Enums';
import { checkButtonAccess } from 'src/utils/common';
import { axiosGetCall, axiosPostCall } from 'src/services/apisCall';
import SaveIcon from '@mui/icons-material/Save';
const RowTow = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
}));


const WhatsappPlansModal = ({ openModal, forceLoad, loadit, handleCloseModal, title, edit, data }) => {
    const theme = useTheme();
    const inputSx = {
        color: theme.palette.text.primary,
        // borderColor: 'grey.700',
        borderRadius: "6px",
    };
    const [loading, setLoading] = useState(false);
    const [planName, setPlanName] = useState(edit ? data?.name : '');
    const [country, setCountry] = useState(edit ? data?.country : '');
    const [utilityRate, setUtilityRate] = useState(edit ? data?.utility : '');
    const [authRate, setAuthRate] = useState(edit ? data?.auth : '');
    const [marketRate, setMarketRate] = useState(edit ? data?.market : '');
    const [type, setType] = useState(edit ? data?.type : '');
    const [templateType, setTemplateType] = useState(edit ? data?.templateType : '');
    const [creditPerTemplate, setCreditPerTemplate] = useState(edit ? data?.creditPerTemplate : '');
    const [openRate, setOpenRate] = useState(edit ? data?.open : '');

    const [error, setError] = useState({});
    const handleClear = () => {
        setPlanName('');
        setCountry('');
        setUtilityRate('');
        setAuthRate('');
        setOpenRate('');
        setMarketRate('');
        setType('');
        setTemplateType('');
        setCreditPerTemplate('');
        setError({});
    };
    const handleChange = async (e) => {
        setLoading(true);
        e.preventDefault();
        const errorTemp = {};
        if (!country) {
            errorTemp.country = "Country is required";
        }
        if (!planName) {
            errorTemp.planName = "planName is required";
        }
        if (type == "A") {
        if (!utilityRate) {
            errorTemp.utilityRate = "utilityRate is required";
        }
        if (!authRate) {
            errorTemp.authRate = "authRate is required";
        }
        if (!openRate) {
            errorTemp.openRate = "openRate is required";
        }
        if (!marketRate) {
            errorTemp.marketRate = "marketRate is required";
        }
       } 
       else{
        if (!templateType) {
            errorTemp.templateType = "templateType is required";
        }
        if (!creditPerTemplate) {
            errorTemp.creditPerTemplate = "creditPerTemplate is required";
        }
       }
        if (!type) {
            errorTemp.type = "Type is required";
        }
        setError(errorTemp);
        if (Object.keys(errorTemp).length === 0) {
            try {
                let data;
                if (type == "A") {
                data = await axiosGetCall("addWhatsappPlan", { countryCode: country, name: planName, utility: utilityRate, auth: authRate, market: marketRate, planType: type,open: openRate });
                } else {
                    data = await axiosGetCall("addWhatsAppCreditPlans", { countryCode: country, name: planName, templateType: templateType, creditPerTemplate: creditPerTemplate, planType: type });
                }
                 const message = data?.message;
                renderSuccessMessage(message);
                handleClear();
                handleCloseModal();
                forceLoad(!loadit)
                setLoading(false);
            } catch (error) {
                console.log("error", error);
                renderErrorMessage(error?.message);
                setLoading(false);
            }
        }
    };
    const description = (
        <Box
            component="form"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '25px',
                width: '100%',
                padding: '25px'
            }}
            noValidate
            autoComplete="off"
        >
            <RowTow>
                <FormControl fullWidth error={error.type}>
                    <InputLabel id="demo-simple-select-label">PlanType</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={type}
                        label="Country*"
                        onChange={(e) => setType(e.target.value)}
                        name="type"
                    >
                        {Object.entries(PLAN_TYPE).map(([code, planType]) => (
                            <MenuItem key={code} value={code}>{planType}</MenuItem>
                        ))}

                    </Select>
                    {error.type && <FormHelperText>{error.type}</FormHelperText>}
                </FormControl>

            </RowTow>
            {type == "A" ? <>
                <RowTow>
                    <FormControl fullWidth error={error.country}>
                        <InputLabel id="demo-simple-select-label">Country</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={country}
                            label="Country*"
                            onChange={(e) => setCountry(e.target.value)}
                            name="Country"
                        >
                            {Object.entries(allowedCountries).map(([code, country]) => (
                                <MenuItem key={code} value={code}>{country}</MenuItem>
                            ))}

                        </Select>
                        {error.country && <FormHelperText>{error.country}</FormHelperText>}
                    </FormControl>

                </RowTow>
                <RowTow>
                    <FormControl fullWidth error={error.planName}>
                        <TextField
                            fullWidth
                            id="textField"
                            label="Plan Name"
                            type='text'
                            variant="outlined"
                            InputProps={{
                                sx: inputSx,
                            }}
                            value={planName}
                            onChange={(e) => setPlanName(e.target.value)}
                            size="large"
                        />

                        {error.planName && <FormHelperText>{error.planName}</FormHelperText>}
                    </FormControl>
                    </RowTow>
                    <RowTow>
                    <FormControl fullWidth error={error.marketRate}>
                        <TextField
                            fullWidth
                            label="Market Rate"
                            type='number'
                            variant="outlined"
                            InputProps={{
                                sx: inputSx,
                            }}
                            value={marketRate}
                            onChange={(e) => setMarketRate(e.target.value)}
                            size="large"
                        />

                        {error.marketRate && <FormHelperText>{error.marketRate}</FormHelperText>}
                    </FormControl>
                    <FormControl fullWidth error={error.utilityRate}>
                        <TextField
                            fullWidth
                            label="Utility Rate"
                            type='number'
                            variant="outlined"
                            InputProps={{
                                sx: inputSx,
                            }}
                            value={utilityRate}
                            onChange={(e) => setUtilityRate(e.target.value)}
                            size="large"
                        />

                        {error.utilityRate && <FormHelperText>{error.utilityRate}</FormHelperText>}
                    </FormControl>
                </RowTow>
                <RowTow>
                    
                    <FormControl fullWidth error={error.authRate}>
                        <TextField
                            fullWidth
                            label="Auth Rate"
                            type='number'
                            variant="outlined"
                            InputProps={{
                                sx: inputSx,
                            }}
                            value={authRate}
                            onChange={(e) => setAuthRate(e.target.value)}
                            size="large"
                        />

                        {error.authRate && <FormHelperText>{error.authRate}</FormHelperText>}
                    </FormControl>
                    <FormControl fullWidth error={error.openRate}>
                        <TextField
                            fullWidth
                            label="Open Rate"
                            type='number'
                            variant="outlined"
                            InputProps={{
                                sx: inputSx,
                            }}
                            value={openRate}
                            onChange={(e) => setOpenRate(e.target.value)}
                            size="large"
                        />

                        {error.openRate && <FormHelperText>{error.openRate}</FormHelperText>}
                    </FormControl>
                </RowTow>
            </> : <>
            <RowTow>
                <FormControl fullWidth error={error.planName}>
                    <TextField
                        fullWidth
                        label="Plan Name"
                        type='text'
                        variant="outlined"
                        InputProps={{
                            sx: inputSx,
                        }}
                        value={planName}
                        onChange={(e) => setPlanName(e.target.value)}
                        size="large"
                    />

                    {error.planName && <FormHelperText>{error.planName}</FormHelperText>}
                </FormControl>
                <FormControl fullWidth error={error.country}>
                        <InputLabel id="demo-simple-select-label">Country</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={country}
                            label="Country*"
                            onChange={(e) => setCountry(e.target.value)}
                            name="Country"
                        >
                            {Object.entries(allowedCountries).map(([code, country]) => (
                                <MenuItem key={code} value={code}>{country}</MenuItem>
                            ))}

                        </Select>
                        {error.country && <FormHelperText>{error.country}</FormHelperText>}
                    </FormControl>
            </RowTow>
            <RowTow>
            <FormControl fullWidth error={error.templateType}>
                    <InputLabel id="demo-simple-select-label">Template Type</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={templateType}
                        label="templateType*"
                        onChange={(e) => setTemplateType(e.target.value)}
                        name="templateType"
                    >
                        {Object.entries(WA_TEMPLATE_TYPE).map(([code, planType]) => (
                            <MenuItem key={code} value={code}>{planType}</MenuItem>
                        ))}

                    </Select>
                    {error.templateType && <FormHelperText>{error.templateType}</FormHelperText>}
                </FormControl>
                
                <FormControl fullWidth error={error.creditPerTemplate}>
                    <TextField
                        fullWidth
                        label="CreditPer Template"
                        type='text'
                        variant="outlined"
                        InputProps={{
                            sx: inputSx,
                        }}
                        value={creditPerTemplate}
                        onChange={(e) => setCreditPerTemplate(e.target.value)}
                        size="large"
                    />

                    {error.creditPerTemplate && <FormHelperText>{error.creditPerTemplate}</FormHelperText>}
                </FormControl>
                </RowTow>
            </>
            }

            <Box sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                pt: '10px',
                pb: '20px'
            }}>
                <LoadingButton
                    style={{ width: "120px", minWidth: "40px" }}
                    size="small"
                    color="primary"
                    variant='outlined'
                    onClick={(e) => handleChange(e)}
                    disabled={!checkButtonAccess("updateWhatsApp", "w")}
                    loading={loading} 
                    loadingPosition="start"
                >
                    {edit ? "Update" : "Create"}
                </LoadingButton>
            </Box>
        </Box>
    );

    return openModal && (
        <CustomModal
            open={openModal}
            title={title}
            description={description}
            close={handleCloseModal}
            isCloseIcon={true}
        />
    );
};
export default WhatsappPlansModal;